let AP: any = null;
// simple-xdm relies on window object. It is not available in SSR.
if (typeof window !== 'undefined') {
	// unable to evaluate fg('platform_deprecate_lp_cc_embed') at the module level and using uniqueKey query param (which is feature gated) instead
	let hasUniqueKey = false;
	if (typeof window !== 'undefined') {
		try {
			hasUniqueKey = new URL(window.location.href).searchParams.has('uniqueKey');
		} catch (e) {
			hasUniqueKey = false;
		}
	}
	AP = hasUniqueKey
		? require('@atlassian/simple-xdm/dist/iframe')
		: require('simple-xdm/dist/iframe');
}

export function requireModule<Module>(name: string): Module | null | undefined {
	if (!AP) {
		return null;
	}

	let requiredModule: Module | null | undefined;

	try {
		AP.require(name, (module: Module) => {
			requiredModule = module;
		});
	} catch (e) {
		requiredModule = null;
	}

	return requiredModule;
}
